import AddBrand from './BrandAdd';
import BrandListing from './BrandListing';
import EditBrand from './BrandEdit';
import TrainerListing from './TrainerListing';
import EditTrainer from './TrainerEdit';
import TrainerNCEPListing from './TrainerNCEPListing';
import EditNCEPTrainer from './TrainerNCEPEdit';
export {
  AddBrand,
  EditBrand,
  BrandListing,
  TrainerListing,
  EditTrainer,
  TrainerNCEPListing,
  EditNCEPTrainer
}



// WEBPACK FOOTER //
// ./src/components/manageBrands/index.js